export const UIActionType = {
  RESET_UI_DATA: "RESET_UI_DATA",
  SET_SNACKBAR: "SET_SNACKBAR",
  SET_EMAIL: "SET_EMAIL",
  SET_NETWORK: "SET_NETWORK",
  SET_THEME: "SET_THEME",
  SET_LOADING: "SET_LOADING",
  SET_IS_DATA_FETCHED: "SET_IS_DATA_FETCHED",
};
